import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormProvider, useForm, useWatch } from 'react-hook-form';

import { PageForm } from 'shared-components/PageForm';
import { StepNavigatorButtons } from 'components/OverviewFlow/StepNavigatorButtons';
import { EligibilityPageWrapper } from './styles';
import { updateOverviewStep } from 'store/overview';

function Eligibility (props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { onBack } = props;
  const methods = useForm({
    defaultValues : {
      1 : null,
      2 : null,
      3 : null,
      4 : null,
    },
  });
  const intendedRoute = useSelector(
    ({ application }) => application.intendedRoute
  );
  const {
    formState: { isValid },
    control,
  } = methods;
  const ageAnswer = useWatch({ name: '1', control });
  const isAgeAnswerNo = ageAnswer && ageAnswer.split('_')[1] === '2';
  const residencyAnswer = useWatch({ name: '2', control });
  const isResidencyAnswerNo =
    residencyAnswer && residencyAnswer.split('_')[1] === '2';
  const userType = useWatch({ name: '3', control });
  const isParent = userType && userType.split('_')[1] === '2';
  const diagnosis = useWatch({ name: '4', control });
  const isAutosomalRecessive = diagnosis && diagnosis.split('_')[1] === '2';
  const noPKD = diagnosis && diagnosis.split('_')[1] === '4';

  const handleOnForward = () => {
    const navigateRoute = isResidencyAnswerNo
      ? '/not-eligible'
      : isAutosomalRecessive
        ? '/select-diagnosis'
        : noPKD
          ? '/i-do-not-have-pkd'
          : '/create-account';

    navigate(navigateRoute, { replace: true });
  };

  const getPersonTypes = () => {
    const personTypes = [
      {
        id    : '3_1',
        label : 'Self',
        value : 'yes',
      },
      {
        id    : '3_2',
        label : 'Parent/Legal Guardian',
        value : 'no',
      },
      {
        id    : '3_3',
        label : 'Other',
        value : 'no',
      },
      {
        id    : '3_4',
        label : 'Not Specified',
        value : 'no',
      },
    ];
    return personTypes.filter((personType) =>
      isAgeAnswerNo ? personType.id === '3_2' : personType.id !== '3_2'
    );
  };

  useEffect(() => {
    dispatch(updateOverviewStep('Eligibility'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const questions = [
    {
      id            : '1',
      questionTitle : 'Are you 18 at least?',
      questionType  : 'radio',
      rules         : { required: { value: true, message: 'This field is required' } },
      items         : [
        {
          id    : '1_1',
          label : 'Yes',
          value : 'yes',
        },
        {
          id    : '1_2',
          label : 'No',
          value : 'no',
        },
      ],
    },
    {
      id            : '2',
      rules         : { required: { value: true, message: 'This field is required' } },
      questionTitle : 'Do you reside in the United States?',
      questionType  : 'radio',
      items         : [
        {
          id    : '2_1',
          label : 'Yes',
          value : 'yes',
        },
        {
          id    : '2_2',
          label : 'No',
          value : 'no',
        },
      ],
    },
    {
      id : '3',
      questionTitle :
        'Are you reporting about yourself or your child / dependent?',
      questionType             : 'select',
      showHelperTextIfSelected : '1_2',
      rules                    : { required: { value: true, message: 'This field is required' } },
      questionHelperText       : isParent
        ? 'If you are filling this form out for someone else, please ensure that you use their name and contact information for registration.'
        : '',
      items : getPersonTypes(),
    },
    {
      id            : '4',
      questionTitle : 'What is patient\'s diagnosis?',
      questionType  : 'select',
      rules         : { required: { value: true, message: 'This field is required' } },
      items         : [
        {
          id    : '4_1',
          label : 'Autosomal Dominant (ADPKD)',
          value : 'yes',
        },
        {
          id    : '4_2',
          label : 'Autosomal Recessive (ARPKD)',
          value : 'no',
        },
        {
          id    : '4_3',
          label : 'Diagnosis Unknown',
          value : 'no',
        },
        {
          id    : '4_4',
          label : 'I do not have PKD',
          value : 'no',
        },
        {
          id    : '4_5',
          label : 'Not Specified',
          value : 'no',
        },
      ],
    },
  ];

  return (
    <EligibilityPageWrapper>
      <FormProvider
        {...methods}>
        <PageForm
          questions={questions} methods={methods}
        />
        <StepNavigatorButtons
          onForward={handleOnForward}
          onBack={onBack}
          hasFormCheck
          formValid={isValid}
        />
      </FormProvider>
    </EligibilityPageWrapper>
  );
}

export default Eligibility;
